import { SortDirection, type SortDirectionType } from '@/api/types';

import { directorStatusBadges } from '../common';
import type { DirectorRow } from './use-director-rows';

const sortValues: Record<string, (_row: DirectorRow) => string> = {
  director: (row) => row.name,
  email: (row) => row.email,
  invitation: (row) => directorStatusBadges[row.status].label,
};

export const sortDirectorRows = (
  rows: DirectorRow[],
  sortKey: string | null,
  sortDirection: SortDirectionType | null,
): DirectorRow[] => {
  const valueOf = sortKey ? sortValues[sortKey] : undefined;

  if (!valueOf || !sortDirection) return rows;

  const factor = sortDirection === SortDirection.ASC ? 1 : -1;

  return [...rows].sort((a, b) => {
    const left = valueOf(a);
    const right = valueOf(b);

    if (!left || !right) return left ? -1 : right ? 1 : 0;

    return left.localeCompare(right) * factor;
  });
};
